$(document).on('turbolinks:load', function(){
    $(".alert-success").delay(4000).slideUp(500, function(){});
    $(".alert-danger").delay(6000).slideUp(500, function(){})

    $(".close-alert-x").on('click', () => {
        $(".alert-success").toggle(false)
        $(".alert-danger").toggle(false)
    })
});